import { createFileRoute } from "@tanstack/react-router";

import { MetalTransfer } from "./-components/MetalTransfer";

export const Route = createFileRoute("/_authenticated/trade/metal-transfer")({
  component: MetalTransfer,
  context: () => ({ permissions: "trade.metal-transfer" }),
});
